import { ApolloClient, createNetworkInterface } from "react-apollo";
const networkInterface = createNetworkInterface({
  uri: "https://api.graph.cool/simple/v1/cj6nxkozy20nl01433229h8b3"
});
networkInterface.use([
  {
    applyMiddleware(req, next) {
      if (!req.options.headers) {
        req.options.headers = {};
      }

      // get the authentication token from local storage if it exists
      if (localStorage.getItem("gToken")) {
        req.options.headers.authorization = `Bearer ${localStorage.getItem(
          "gToken"
        )}`;
      }
      next();
    }
  }
]);
export const client = new ApolloClient({
  networkInterface: networkInterface
});



// WEBPACK FOOTER //
// ./client/client.js